module.exports = __webpack_public_path__ + "/d72293118cda50ec50c39957d9d836d0.svg";